import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getGutters } from '@/src/materialui/container/container.theme';

export const flowToolbar: Components<Theme>['MuiToolbar'] = {
  defaultProps: {
    disableGutters: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // in order for HeaderNavigationHero to fill full width, we are setting position to static from relative
      position: 'static',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      margin: '0 auto',
      width: '100%',
      // default gutters
      paddingLeft: '16px',
      paddingRight: '16px',
      // height controlled by appbar
      [theme.breakpoints.up('xs')]: {
        minHeight: '0',
      },
    }),
    // same proportions as container
    gutters: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: getGutters('xs'),
      [theme.breakpoints.up('sm')]: getGutters('sm'),
      [theme.breakpoints.up('md')]: getGutters('md'),
      [theme.breakpoints.up('lg')]: getGutters('lg'),
      [theme.breakpoints.up('xl')]: {
        ...getGutters('xl'),
        // container maxWidthXl
        maxWidth: theme.breakpoints.values.xl,
      },
    }),
    dense: {
      // remove gutters completely
      padding: '0',
    },
  },
};
